import axios from "./AxiosService";

export default formData => {
  return axios.post("OnboardMember", formData, {
    headers: {
      "Content-Type": "application/json"
    }
  });
};
